<template>
  <section :class="$style.qr">
    <img :src="qrUrl" alt="QRimage" :class="$style.qr__image" />
    <a
      v-if="downloadHref"
      :href="downloadHref"
      :class="$style.qr__button"
      :download="filename"
      @click="onClickDownload"
    >
      ダウンロード
    </a>
  </section>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { getAPIBaseURL, getShadowPlannerChatQRURL } from '@/config'
import { useLogger } from '@/logger/logger'

const props = defineProps<{
  plannerId: number
}>()

const downloadHref = ref<string>()

const filename = computed<string>(() => {
  return `okane-kenko_planner_qr-${props.plannerId}.png`
})

const qrUrl = computed<string>(() => {
  const qrBase = getAPIBaseURL('qr')
  const destinationUrl = getShadowPlannerChatQRURL(props.plannerId)
  const params = new URLSearchParams({ m: destinationUrl })
  return `${qrBase}/?${params}`
})

onMounted(async () => {
  const response = await window.fetch(qrUrl.value)

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  const blob = await response.blob()

  downloadHref.value = window.URL.createObjectURL(blob) // whatwg-url does not have this static method.
})

const logger = useLogger()

const onClickDownload = async () => {
  logger.ltlPeople.event.downloadQr(logger.buildMeta())
}
</script>

<style lang="scss" module>
.qr {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__image {
    display: block;
    height: 80px;
    width: 80px;
  }

  &__button {
    &:nth-child(n + 2) {
      margin-top: 16px;
    }
  }
}
</style>
